import React from "react";
import { FaShoppingCart, FaStore, FaLandmark } from "react-icons/fa";
import "./WhoWeHelpSection.css";

const WhoWeHelpSection = () => {
    return (
        <section className="_wWHSec_m1A_">
            <div className="_sCont_n2B_">
                <h2 className="_sTitle_o3C_" style={{ marginBottom: "1.9rem" }}>
                    Who We Help
                </h2>
                <div className="_hCGrid_p4D_">

                    {/* Customers */}
                    <div className="_hCard_q5E_ feature-item">
                        <div className="feature-icon">
                            <FaShoppingCart />
                        </div>
                        <h4 className="feature-title-text">Customers</h4>
                        <p className="feature-description">
                            We support you with every step of your order—shopping, returns, delivery and secure payment. Quick help via app, web or WhatsApp if you need it.
                        </p>
                    </div>

                    {/* Sellers */}
                    <div className="_hCard_q5E_ feature-item">
                        <div className="feature-icon">
                            <FaStore />
                        </div>
                        <h4 className="feature-title-text">Sellers</h4>
                        <p className="feature-description">
                            Get help with catalog setup, payments, logistics and onboarding. Our team is here to resolve issues fast and help your business thrive.
                        </p>
                    </div>

                    {/* Communities & Groups */}
                    <div className="_hCard_q5E_ feature-item">
                        <div className="feature-icon">
                            <FaLandmark />
                        </div>
                        <h4 className="feature-title-text">Communities & Groups</h4>
                        <p className="feature-description">
                            Dedicated support for group orders, dashboard questions and custom needs—like festival or event delivery, special requests or reporting.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhoWeHelpSection;